import './TableSkeleton.css'

interface TableSkeletonProps {
  rowCount?: number
  colCount?: number
}

export default function TableSkeleton({
  rowCount = 15,
  colCount = 8
}: TableSkeletonProps) {
  const cols = Array.from({ length: colCount })
  const rows = Array.from({ length: rowCount })

  return (
    <div
      className="spreadsheet-container skeleton-container"
      aria-hidden="true"
    >
      <table>
        <thead>
          <tr>
            <th className="sticky-corner">
              <div className="skeleton-pulse header" />
            </th>
            {cols.map((_, i) => (
              <th key={`head-${i}`} className="sticky-top">
                <div className="skeleton-pulse header" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((_, rowIndex) => (
            <tr key={`row-${rowIndex}`}>
              <th className="sticky-left">
                <div className="skeleton-pulse header" />
              </th>
              {cols.map((_, colIndex) => (
                <td key={`cell-${rowIndex}-${colIndex}`}>
                  <div className="skeleton-pulse cell" />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
